import React, { useEffect, useState, useRef, useCallback } from 'react';
import TomSelect from '../../components/common/TomSelect';
import api from '../../api';
// import { useJsApiLoader } from "@react-google-maps/api";
import ConfirmationModal from '../../components/common/ConfirmationModal';
import SuccessModal from '../../components/common/SuccessModal';
import DateRangeFilter from '../../components/common/DateRangeFilter';
import { validateField, validateRequired, validateEmail, validatePhone } from '../../utils/validation';
import FailModal from '../../components/common/FailModal';
import { useSelection } from '../../hooks/useSelection';
import { usePagination } from '../../hooks/usePagination';
import { useAuth } from '../../contexts/AuthProvider';
import { GenericView, SearchInput } from '../../components/common/table';

// Define the libraries to load
// const libraries = ["places"];

const IndividualPartner = () => {
  // Actions dropdown refs for manual Bootstrap Dropdown initialization
  const actionsToggleRef = useRef(null);
  const actionsContainerRef = useRef(null);
  const actionsDropdownInstanceRef = useRef(null);
  const [isActionsOpen, setIsActionsOpen] = useState(false);

  useEffect(() => {
    const toggleEl = actionsToggleRef.current;
    const containerEl = actionsContainerRef.current;
    if (!toggleEl || !containerEl) return;
    if (typeof window !== 'undefined' && window.bootstrap?.Dropdown) {
      const instance = new window.bootstrap.Dropdown(toggleEl, { autoClose: true });
      actionsDropdownInstanceRef.current = instance;
      const onShow = () => setIsActionsOpen(true);
      const onHide = () => setIsActionsOpen(false);
      containerEl.addEventListener('show.bs.dropdown', onShow);
      containerEl.addEventListener('hide.bs.dropdown', onHide);
      return () => {
        containerEl.removeEventListener('show.bs.dropdown', onShow);
        containerEl.removeEventListener('hide.bs.dropdown', onHide);
        try { instance.dispose(); } catch {}
        actionsDropdownInstanceRef.current = null;
      };
    }
  }, []);

  // Use global auth context with capabilities
  const { user, can, capabilitiesLoading } = useAuth();
  
  // Helper function to check individualPartner-specific capabilities
  const canIndividualPartner = (capabilityKey) => can(capabilityKey, 'individualPartner');

  // Pagination
  const pagination = usePagination(10);

  // Selection
  const {
    selectedIds,
    setSelectedIds,
    handleCheckboxClick,
    handleSelectAll
  } = useSelection();

  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('');
  const [individualPartners, setIndividualPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [showFailModal, setShowFailModal] = useState(false);
  const [failMessage, setFailMessage] = useState('');

  // Add Google Maps API loader
  // const { isLoaded, loadError } = useJsApiLoader({
  //   googleMapsApiKey: "AIzaSyAAHKz5tes9kExmji4EOCRtq5IqSQmKR9w",
  //   libraries: libraries,
  //   version: "weekly"
  // });

  // useEffect(() => {
  //   // Ensure Google Maps API is loaded
  //   if (window.google && window.google.maps) {
  //     // Initialize Autocomplete
  //     const autocomplete = new window.google.maps.places.Autocomplete(
  //       businessLocationRef.current,
  //       {
  //         types: ['geocode'], // Restrict to address types
  //       }
  //     );

  //     // Listen for place selection
  //     autocomplete.addListener('place_changed', () => {
  //       const place = autocomplete.getPlace();
  //       if (!place || !place.geometry) {
  //         return;
  //       }
  //       const addressComponents = place.address_components;
  //       let country = '';
  //       let state = '';
  //       let city = '';
  //       let postalCode = '';
  //       for (const component of addressComponents) {
  //         const types = component.types;
  //         if (types.includes('country')) {
  //           country = component.long_name;
  //         } else if (types.includes('administrative_area_level_1')) {
  //           state = component.long_name;
  //         } else if (types.includes('administrative_area_level_2')) {
  //           city = component.long_name;
  //         } else if (types.includes('locality') && !city) {
  //           city = component.long_name;
  //         } else if (types.includes('postal_code')) {
  //           postalCode = component.long_name;
  //         }
  //       }
  //       setFormData(prevData => ({
  //         ...prevData,
  //         businessLocation: place.formatted_address,
  //         address: place.formatted_address,
  //         country,
  //         state,
  //         city,
  //         postalCode
  //       }));
  //     });

  //     // Cleanup listener
  //     return () => {
  //       window.google.maps.event.clearInstanceListeners(autocomplete);
  //     };
  //   }
  // }, []); // Empty dependency array ensures this runs once

  // Optional: Helper function to extract specific address components
  // const findAddressComponent = (components, type) => {
  //   return components?.find(component =>
  //     component.types.includes(type)
  //   )?.long_name || '';
  // };

  // Add refs
  // const businessLocationRef = useRef(null);
  // const editLocationRef = useRef(null);
  // const editModalRef = useRef(null);

  // State declarations
  const [editingId, setEditingId] = useState(null);
  const [locationData, setLocationData] = useState({
    name: '',
    address: '',
    latitude: null,
    longitude: null,
    negara: '',
    province: '',
    city: '',
    kecamatan: ''
  });

  // State for managing form data
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    individualPartnerType: '',
    description: '',
    generatePassword: false,
    password: '',
    confirmPassword: '',
    businessLocation: '',
    postalCode: '',
    country: '',
    state: '',
    city: ''
  });

  // State for tracking validation errors
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  // State for password visibility
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // Add state for partner types
  const [partnerTypes, setPartnerTypes] = useState([]);

  // References for TomSelect elements using our custom hook
  // Removed companySelectRef as company is not needed

  const [search, setSearch] = useState('');
  const [appliedSearchTerm, setAppliedSearchTerm] = useState('');

  const handleSearchInputChange = (value) => {
    setSearch(value);
    setSearchTerm(value);
  };

  const handleSearchSubmit = () => {
    setAppliedSearchTerm(searchTerm);
    pagination.setPage(0);
  };

  // Update fetchIndividualPartners to use pagination and search
  const fetchIndividualPartners = async (query = '') => {
    setLoading(true);
    try {
      const response = await api.get('/md/individual-partner/list', {
        params: {
          page: pagination.page,
          size: pagination.size,
          query: query || appliedSearchTerm,
          typeId: filterType || undefined
        }
      });
      setIndividualPartners(response.data.content || []);
      pagination.setTotalPages(response.data.totalPages || 1);
      pagination.setTotal(response.data.totalElements);
      pagination.setCurrentPageItems(response.data.content.length);
    } catch (error) {
      let errorMessage = 'Failed to fetch individual partners.';
      let technicalDetails = '';
      
      if (error.response) {
        switch (error.response.status) {
          case 403:
            errorMessage = 'You do not have permission to view individual partners.';
            technicalDetails = 'Required role or permission is missing';
            break;
          case 500:
            errorMessage = 'Server encountered an error while fetching partners.';
            technicalDetails = error.response.data.message || 'Internal server error occurred';
            break;
          default:
            errorMessage = 'An error occurred while fetching individual partners.';
            technicalDetails = `Server responded with status: ${error.response.status}`;
        }
      } else if (error.request) {
        errorMessage = 'Unable to connect to the server.';
        technicalDetails = 'Network error or server is not responding';
      } else {
        errorMessage = 'An unexpected error occurred.';
        technicalDetails = error.message;
      }
      
      setFailMessage(`${errorMessage}\n\nTechnical Details: ${technicalDetails}`);
      setShowFailModal(true);
      setIndividualPartners([]);
    } finally {
      setLoading(false);
    }
  };

  // Trigger fetch when page, size, search, or filterType changes
  useEffect(() => {
    fetchIndividualPartners();
  }, [pagination.page, pagination.size, appliedSearchTerm, filterType]);

  // Handler filter
  const handleFilterTypeChange = (e) => {
    setFilterType(e.target.value);
    pagination.setPage(0);
  };

  // Add separate effect to update TomSelect value when editData changes
  useEffect(() => {
    if (partnerTypeSelectRef.current?.tomselect && editingId) {
      partnerTypeSelectRef.current.tomselect.setValue(editingId.toString(), true); // Silent update
    }
  }, [editingId]);

  useEffect(() => {
    const fetchPartnerTypes = async () => {
      try {
        const response = await api.get('/md/individual-partner-type');

        // Check if response.data exists and is an array
        if (response.data && Array.isArray(response.data)) {
          setPartnerTypes(response.data);
        } else {
          setPartnerTypes([]);
        }
      } catch (error) {
        let errorMessage = 'Failed to fetch partner types.';
        let technicalDetails = '';
        
        if (error.response) {
          switch (error.response.status) {
            case 403:
              errorMessage = 'You do not have permission to view partner types.';
              technicalDetails = 'Required role or permission is missing';
              break;
            case 500:
              errorMessage = 'Server error while fetching partner types.';
              technicalDetails = error.response.data.message || 'Internal server error occurred';
              break;
            default:
              errorMessage = 'An error occurred while fetching partner types.';
              technicalDetails = `Server responded with status: ${error.response.status}`;
          }
        } else if (error.request) {
          errorMessage = 'Unable to connect to the server.';
          technicalDetails = 'Network error or server is not responding';
        } else {
          errorMessage = 'An unexpected error occurred.';
          technicalDetails = error.message;
        }
        
        setFailMessage(`${errorMessage}\n\nTechnical Details: ${technicalDetails}`);
        setShowFailModal(true);
        setPartnerTypes([]);
      }
    };

    fetchPartnerTypes();
  }, []);

  // Handle create (open modal for new)
  const handleCreate = () => {
    if (!canIndividualPartner('create')) {
      setFailMessage('You do not have permission to create individual partners.');
      setShowFailModal(true);
      return;
    }
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      address: '',
      individualPartnerType: '',
      description: '',
      generatePassword: false,
      password: '',
      confirmPassword: '',
      businessLocation: '',
      postalCode: '',
      country: '',
      state: '',
      city: '',
      allowLogin: false
    });
    setEditingId(null);
    setErrors({});
    setSubmitted(false);
    setShowModal(true);
    const modal = new window.bootstrap.Modal(document.getElementById("modal-individual-partner"), {
      backdrop: 'static',
      keyboard: true
    });
    modal.show();
  };

  // Handle edit (open modal for edit)
  const handleEdit = (partner) => {
    if (!canIndividualPartner('edit')) {
      setFailMessage('You do not have permission to edit individual partners.');
      setShowFailModal(true);
      return;
    }
    setFormData({
      firstName: partner.firstName || '',
      lastName: partner.lastName || '',
      email: partner.email || '',
      phone: partner.phone || '',
      address: partner.address || '',
      individualPartnerType: partner.individualPartnerType?.id || '',
      description: partner.description || '',
      businessLocation: partner.businessLocation || '',
      postalCode: partner.postalCode || '',
      country: partner.country || '',
      state: partner.state || '',
      city: partner.city || '',
      allowLogin: partner.allowLogin ?? false,
      // Remove password-related fields in edit mode
      generatePassword: false,
      password: '',
      confirmPassword: ''
    });
    setEditingId(partner.id);
    setErrors({});
    setSubmitted(false);
    setShowModal(true);
    const modal = new window.bootstrap.Modal(document.getElementById("modal-individual-partner"), {
      backdrop: 'static',
      keyboard: true
    });
    modal.show();
  };

  // Unified handleSubmit for both create and edit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true); // Mark form as submitted to show all validation errors
    
    // Run validation
    const isValid = validateForm();
    if (!isValid) {
      return; // Stop submission if validation fails
    }

    try {
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        businessLocation: formData.businessLocation || formData.address,
        country: formData.country || "Indonesia",
        state: formData.state || "Jakarta",
        city: formData.city || "Jakarta",
        allowLogin: true,//formData.allowLogin,
        password: formData.password,
        postalCode: formData.postalCode,
        description: formData.description || '',
        individualPartnerType: {
          id: parseInt(formData.individualPartnerType)
        }
      };
      if (formData.allowLogin) {
        payload.createLogin = true;
        payload.password = formData.generatePassword
          ? Math.random().toString(36).slice(-10) + Math.random().toString(36).toUpperCase().slice(-2) + "!2"
          : formData.password;
      }
      if (editingId) {
        await api.put(`/md/individual-partner/${editingId}`, payload);
        setSuccessMessage('Individual partner updated successfully!');
      } else {
        await api.post('/md/individual-partner', payload);
        setSuccessMessage('Individual partner created successfully!');
      }
      setShowSuccessModal(true);
      setShowModal(false);
      setEditingId(null);
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        individualPartnerType: '',
        description: '',
        generatePassword: false,
        password: '',
        confirmPassword: '',
        businessLocation: '',
        postalCode: '',
        country: '',
        state: '',
        city: '',
        allowLogin: false
      });
      setErrors({});
      setSubmitted(false);
      await fetchIndividualPartners();
      const modal = document.getElementById('modal-individual-partner');
      const bootstrapModal = window.bootstrap?.Modal.getInstance(modal);
      if (bootstrapModal) {
        bootstrapModal.hide();
        setTimeout(() => setShowSuccessModal(true), 300);
      } else {
        setShowSuccessModal(true);
      }
    } catch (error) {
      let errorMessage = 'Failed to save individual partner.';
      let technicalDetails = '';
      
      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMessage = 'Invalid individual partner data provided.';
            technicalDetails = error.response.data.message || 'The server rejected the request due to invalid data';
            break;
          case 403:
            errorMessage = 'You do not have permission to perform this action.';
            technicalDetails = 'Required role or permission is missing';
            break;
          case 409:
            errorMessage = 'A partner with this information already exists.';
            technicalDetails = error.response.data.message || 'Duplicate entry detected';
            break;
          case 500:
            errorMessage = 'Server encountered an error while saving.';
            technicalDetails = error.response.data.message || 'Internal server error occurred';
            break;
          default:
            errorMessage = 'An error occurred while saving the individual partner.';
            technicalDetails = `Server responded with status: ${error.response.status}`;
        }
      } else if (error.request) {
        errorMessage = 'Unable to connect to the server.';
        technicalDetails = 'Network error or server is not responding';
      } else {
        errorMessage = 'An unexpected error occurred.';
        technicalDetails = error.message;
      }
      
      setFailMessage(`${errorMessage}\n\nTechnical Details: ${technicalDetails}`);
      setShowFailModal(true);
    }
  };

  // Delete selected partners
  const deleteSelected = () => {
    if (!canIndividualPartner('delete')) {
      setFailMessage('You do not have permission to delete individual partners.');
      setShowFailModal(true);
      return;
    }
    if (selectedIds.length === 0) {
      setFailMessage('Please select at least one individual partner to delete.\n\nTechnical Details: No items selected for deletion');
      setShowFailModal(true);
      return;
    }
    setConfirmAction(() => async () => {
      try {
        await api.delete(`/md/individual-partner/${selectedIds}`);
        setSelectedIds([]);
        fetchIndividualPartners();
        setShowConfirmModal(false);
        setSuccessMessage('Selected individual partners have been successfully deleted.');
        setShowSuccessModal(true);
      } catch (error) {
        let errorMessage = 'Failed to delete individual partners.';
        let technicalDetails = '';
        
        if (error.response) {
          switch (error.response.status) {
            case 403:
              errorMessage = 'You do not have permission to delete these items.';
              technicalDetails = 'Required role or permission is missing';
              break;
            case 404:
              errorMessage = 'One or more individual partners not found.';
              technicalDetails = 'Some items may have been already deleted';
              break;
            case 500:
              errorMessage = 'Server error while deleting items.';
              technicalDetails = error.response.data.message || 'Internal server error during deletion';
              break;
            default:
              errorMessage = 'An error occurred while deleting the items.';
              technicalDetails = `Server responded with status: ${error.response.status}`;
          }
        } else if (error.request) {
          errorMessage = 'Unable to connect to the server.';
          technicalDetails = 'Network error or server is not responding';
        } else {
          errorMessage = 'An unexpected error occurred during deletion.';
          technicalDetails = error.message;
        }
        
        setShowConfirmModal(false);
        setFailMessage(`${errorMessage}\n\nTechnical Details: ${technicalDetails}`);
        setShowFailModal(true);
      }
    });
    setShowConfirmModal(true);
  };

  // Edit selected partner (only works for single selection)
  const editSelected = () => {
    if (!canIndividualPartner('edit')) {
      setFailMessage('You do not have permission to edit individual partners.');
      setShowFailModal(true);
      return;
    }
    if (selectedIds.length !== 1) {
      alert('Please select exactly one partner to edit');
      return;
    }

    const selectedId = selectedIds[0];
    const selectedPartner = individualPartners.find(partner => partner.id === selectedId);

    if (selectedPartner) {
      handleEdit(selectedPartner);
    }
  };

  // Add refs
  const partnerTypeSelectRef = useRef(null);

  // Function to handle select changes (TomSelect)
  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    // Real-time validation for select fields
    let error = null;
    if (name === 'individualPartnerType') {
      error = validateField('individualPartnerType', value, { required: true });
    }
    setErrors((prev) => ({
      ...prev,
      [name]: error
    }));
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    // Real-time validation
    let error = null;
    if (name === 'email') {
      error = validateField('email', value, { required: true, type: 'email' });
    } else if (name === 'phone') {
      error = validateField('phone', value, { required: true, type: 'phone' });
    } else if (name === 'firstName' || name === 'lastName') {
      error = validateField(name, value, { required: true, minLength: 2 });
    } else if (name === 'address') {
      error = validateField('address', value, { required: true, minLength: 5, maxLength: 500 });
    } else if (name === 'postalCode') {
      error = validateField('postalCode', value, { required: true, type: 'postalCode' });
    // } else if (name === 'businessLocation') {
    //   error = validateField('businessLocation', value, { required: true });
    // } else if (name === 'password' || name === 'confirmPassword') {
      // Password validation only if login is enabled and not generating password
      if (formData.allowLogin && !formData.generatePassword) {
        if (name === 'password') {
          if (!value) error = 'Password is required';
          else if (value.length < 8) error = 'Password must be at least 8 characters';
        }
        if (name === 'confirmPassword') {
          if (!value) error = 'Please confirm your password';
          else if (value !== formData.password) error = 'Passwords do not match';
        }
      }
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error
    }));
  };

  // Validate form before submission
  const validateForm = () => {
    const newErrors = {};
    newErrors.firstName = validateRequired(formData.firstName, 'First name');
    newErrors.lastName = validateRequired(formData.lastName, 'Last name');
    newErrors.individualPartnerType = validateRequired(formData.individualPartnerType, 'Individual partner type');
    newErrors.email = validateEmail(formData.email) || validateRequired(formData.email, 'Email');
    newErrors.phone = validatePhone(formData.phone) || validateRequired(formData.phone, 'Phone');
    // newErrors.businessLocation = validateRequired(formData.businessLocation, 'Business location');
    newErrors.address = validateRequired(formData.address, 'Address');
    newErrors.postalCode = validateRequired(formData.postalCode, 'Postal code');
    newErrors.country = validateRequired(formData.country, 'Country');
    newErrors.state = validateRequired(formData.state, 'State');
    newErrors.city = validateRequired(formData.city, 'City');
    
    // Only validate password fields for new partners
    if (!editingId) {
      newErrors.password = validateRequired(formData.password, 'Password');
      newErrors.confirmPassword = validateRequired(formData.confirmPassword, 'Confirm password');
    }
    
    setErrors(newErrors);
    return Object.values(newErrors).every(x => !x);
  };

  return (
    <>
      {/* Page header */}
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">
                Individual Partners
              </h2>
            </div>
            {/* Page title actions */}
            <div className="col-auto ms-auto d-print-none">
              <div className="btn-list">
                {canIndividualPartner('create') && (
                  <>
                    <a href="#" className="btn btn-primary d-none d-sm-inline-block"
                      // data-bs-toggle="modal"
                      //  data-bs-target="#modal-individual-partner"
                      onClick={handleCreate}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                        strokeLinejoin="round" className="icon">
                        <path d="M12 5l0 14" />
                        <path d="M5 12l14 0" />
                      </svg>
                      Create
                    </a>
                    <a href="#" className="btn btn-primary d-sm-none btn-icon"
                      // data-bs-toggle="modal"
                      // data-bs-target="#modal-individual-partner" 
                      onClick={handleCreate}
                      aria-label="Create new individual partner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                        strokeLinejoin="round" className="icon">
                        <path d="M12 5l0 14" />
                        <path d="M5 12l14 0" />
                      </svg>
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Page body */}
      <div className="page-body">
        <div className="container-xl">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <GenericView
                  data={individualPartners}
                  columns={[
                    { key: 'firstName', label: 'Name', sortable: true, render: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`.trim() || '-' },
                    { key: 'individualPartnerType', label: 'Individual Partner Type', sortable: true, render: (value, row) => row.individualPartnerType?.name || '-' },
                    { key: 'email', label: 'Email', sortable: true, render: (value) => value || '-' },
                    { key: 'phone', label: 'Phone', sortable: true, render: (value) => value || '-' },
                    { key: 'address', label: 'Address', sortable: true, render: (value) => value || '-' },
                    { key: 'cdate', label: 'Created Date', sortable: true, render: (value) => value ? new Date(value).toLocaleDateString() : '-' },
                  ]}
                  isLoading={loading || capabilitiesLoading}
                  emptyStateMessage="No individual partners found"
                  checkboxSelection={true}
                  selectedRows={selectedIds}
                  onSelectRow={(itemId, isSelected) => {
                    if (isSelected) {
                      setSelectedIds([...selectedIds, itemId]);
                    } else {
                      setSelectedIds(selectedIds.filter(id => id !== itemId));
                    }
                  }}
                  onSelectAllRows={(itemIds) => {
                    if (Array.isArray(itemIds) && itemIds.length > 0) {
                      setSelectedIds([...new Set([...selectedIds, ...itemIds])]);
                    } else {
                      setSelectedIds([]);
                    }
                  }}
                  onEdit={canIndividualPartner('edit') ? (item) => {
                    setSelectedIds([item.id]);
                    handleEdit(item);
                  } : undefined}
                  onDelete={canIndividualPartner('delete') ? (item) => {
                    setSelectedIds([item.id]);
                    deleteSelected();
                  } : undefined}
                  searchComponent={
                    <div className="d-flex gap-2">
                      <SearchInput
                        value={searchTerm}
                        onChange={handleSearchInputChange}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            handleSearchSubmit();
                          }
                        }}
                        placeholder="Search..."
                        uniqueId="individual-partner-search"
                      />
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSearchSubmit}
                      >
                        Search
                      </button>
                      <a className="btn btn-icon" data-bs-toggle="offcanvas" href="#offcanvasEnd"
                        role="button" aria-controls="offcanvasEnd">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                          viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-adjustments">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                          <path d="M6 4v4" />
                          <path d="M6 12v8" />
                          <path d="M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                          <path d="M12 4v10" />
                          <path d="M12 18v2" />
                          <path d="M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                          <path d="M18 4v1" />
                          <path d="M18 9v11" />
                        </svg>
                      </a>
                    </div>
                  }
                  actionButtons={
                    <div className="d-flex gap-2">
                      {(canIndividualPartner('edit') || canIndividualPartner('delete')) && (
                        <div ref={actionsContainerRef} className="dropdown">
                          <a
                            ref={actionsToggleRef}
                            href="#"
                            className="btn dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded={isActionsOpen}
                            onClick={(e) => {
                              e.preventDefault();
                              const inst = actionsDropdownInstanceRef.current;
                              if (inst?.toggle) inst.toggle();
                              else setIsActionsOpen(prev => !prev);
                            }}
                          >Actions</a>
                          <div className="dropdown-menu">
                            {canIndividualPartner('edit') && (
                              <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); editSelected(); }}
                                style={{ color: selectedIds.length === 1 ? "" : "#ccc", pointerEvents: selectedIds.length === 1 ? "auto" : "none" }}>
                                Edit
                              </a>
                            )}
                            {canIndividualPartner('delete') && (
                              <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); deleteSelected(); }}
                                style={{ color: selectedIds.length ? "" : "#ccc", pointerEvents: selectedIds.length ? "auto" : "none" }}>
                                Delete
                              </a>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  }
                  pagination={{
                    currentPage: pagination.page + 1,
                    totalRows: pagination.total,
                    rowsPerPage: pagination.size,
                    onPageChange: (page) => pagination.setPage(page - 1),
                    onRowsPerPageChange: (size) => {
                      pagination.setSize(size);
                      pagination.setPage(0);
                    }
                  }}
                  pageSizeOptions={[10, 25, 50, 100]}
                  uniqueId="individual-partner-table"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* New Individual Partner Modal */}
      <div className="modal modal-blur fade" id="modal-individual-partner"
        tabIndex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">{editingId ? 'Edit Individual Partner' : 'New Individual Partner'}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <TomSelect
                        name="individualPartnerType"
                        value={formData.individualPartnerType}
                        onChange={handleSelectChange}
                        options={partnerTypes}
                        placeholder="Select partner type"
                        label="Individual Partner Type"
                        required={true}
                        error={errors.individualPartnerType}
                        valueField="id"
                        labelField="name"
                        searchField="name"
                      />
                    </div>
                  </div>
                  <div className='col-lg-6'></div>
                  <div className='col-lg-6'>
                    <div className="mb-3">
                      <label className="form-label">First Name <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
                        name="firstName"
                        placeholder="Enter first name"
                        value={formData.firstName}
                        onChange={handleInputChange}
                      />
                      {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className="mb-3">
                      <label className="form-label">Last Name <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className={`form-control ${submitted && errors.lastName ? 'is-invalid' : ''}`}
                        name="lastName"
                        placeholder="Enter last name"
                        value={formData.lastName}
                        onChange={handleInputChange}
                      />
                      {submitted && errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">Email <span className="text-danger">*</span></label>
                      <input
                        type="email"
                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                        name="email"
                        placeholder="Enter email address"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">Phone <span className="text-danger">*</span></label>
                      <input
                        type="tel"
                        className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                        name="phone"
                        placeholder="Enter phone number"
                        value={formData.phone}
                        onChange={handleInputChange}
                      />
                      {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                    </div>
                  </div>

                  {/* <div className='col-lg-8'>
                    <div className="mb-3">
                      <label className="form-label">Business Location <span className="text-danger">*</span></label>
                      <div className="input-icon">
                        <input
                          type="text"
                          className={`form-control ${submitted && errors.businessLocation ? 'is-invalid' : ''}`}
                          name="businessLocation"
                          id="createBusinessLocation"
                          placeholder="Start typing to search address..."
                          value={formData.businessLocation || ''}
                          onChange={handleInputChange}
                          autoComplete="off"
                          ref={businessLocationRef}
                        />
                      </div>
                      {!isLoaded && <div className="form-text text-muted">Loading Google Maps...</div>}
                      {loadError && <div className="form-text text-danger">Error loading Google Maps</div>}
                      {errors.businessLocation && <div className="invalid-feedback">{errors.businessLocation}</div>}
                    </div>
                  </div> */}


                  <div className='col-lg-4'></div>
                  <label className="form-label">Address <span className="text-danger">*</span></label>
                  <div className="col-lg-8">
                    <div className="mb-3">
                      <textarea
                        className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                        name="address"
                        id="addressInput"
                        placeholder="Address"
                        value={formData.address || ''}
                        onChange={handleInputChange}
                        rows="3"
                      />
                      {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <input
                        type="text"
                        className={`form-control ${errors.postalCode ? 'is-invalid' : ''}`}
                        name="postalCode"
                        id="postalInput"
                        placeholder="Postal Code"
                        value={formData.postalCode || ''}
                        onChange={handleInputChange}
                      />
                      {errors.postalCode && <div className="invalid-feedback">{errors.postalCode}</div>}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label className="form-label">Country <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className={`form-control ${errors.country ? 'is-invalid' : ''}`}
                        name="country"
                        id="countryInput"
                        placeholder="Enter country"
                        value={formData.country || ''}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                      {errors.country && <div className="invalid-feedback">{errors.country}</div>}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label className="form-label">State <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className={`form-control ${errors.state ? 'is-invalid' : ''}`}
                        name="state"
                        id="stateInput"
                        placeholder="Enter state"
                        value={formData.state || ''}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                      {errors.state && <div className="invalid-feedback">{errors.state}</div>}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label className="form-label">City <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className={`form-control ${errors.city ? 'is-invalid' : ''}`}
                        name="city"
                        id="cityInput"
                        placeholder="Enter city"
                        value={formData.city || ''}
                        onChange={handleInputChange}
                        autoComplete="off"
                      />
                      {errors.city && <div className="invalid-feedback">{errors.city}</div>}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        placeholder="Enter description (optional)"
                        value={formData.description || ''}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  {/* Only show password fields for new partners */}
                  {!editingId && (
                    <>
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <label className="form-label">Generate Random Password</label>
                          <label className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={formData.generatePassword || false}
                              onChange={(e) =>
                                setFormData({ ...formData, generatePassword: e.target.checked })
                              }
                            />
                            <span className="form-check-label">Auto-generate secure password</span>
                          </label>
                          {formData.generatePassword && (
                            <div className="form-hint text-success">
                              A secure password will be generated and sent to the user's email
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-6"></div>

                      {!formData.generatePassword && (
                        <>
                          <div className="col-lg-6">
                            <div className="mb-3">
                              <label className="form-label">Password</label>
                              <div className="input-group">
                                <input
                                  type={showPassword ? 'text' : 'password'}
                                  className={`form-control ${submitted && errors.password ? 'is-invalid' : ''}`}
                                  name="password"
                                  value={formData.password || ''}
                                  onChange={handleInputChange}
                                  placeholder="Enter password"
                                  autoComplete="off"
                                />
                                <span className="input-group-text cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                                  {showPassword ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-eye-off" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                      <path d="M10.585 10.587a2 2 0 0 0 2.829 2.828"></path>
                                      <path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87"></path>
                                      <path d="M3 3l18 18"></path>
                                    </svg>
                                  ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-eye" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                      <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                                      <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
                                    </svg>
                                  )}
                                </span>
                              </div>
                              {submitted && errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="mb-3">
                              <label className="form-label">Confirm Password</label>
                              <div className="input-group">
                                <input
                                  type={showConfirmPassword ? 'text' : 'password'}
                                  className={`form-control ${submitted && errors.confirmPassword ? 'is-invalid' : ''}`}
                                  name="confirmPassword"
                                  value={formData.confirmPassword || ''}
                                  onChange={handleInputChange}
                                  placeholder="Re-enter password"
                                  autoComplete="off"
                                />
                                <span className="input-group-text cursor-pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                  {showConfirmPassword ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-eye-off" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                      <path d="M10.585 10.587a2 2 0 0 0 2.829 2.828"></path>
                                      <path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87"></path>
                                      <path d="M3 3l18 18"></path>
                                    </svg>
                                  ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-eye" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                      <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                                      <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
                                    </svg>
                                  )}
                                </span>
                              </div>
                              {submitted && errors.confirmPassword && <div className="invalid-feedback d-block">{errors.confirmPassword}</div>}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}

                </div>
              </div>
              <div className="modal-footer">
                <a href="#" className="btn btn-link link-secondary btn-3"
                  data-bs-dismiss="modal">
                  Cancel
                </a>
                <button type="submit" className="btn btn-primary ms-auto" id="createBtn">
                  {editingId ? 'Update' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Filter Offcanvas */}
      <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasEnd" aria-labelledby="offcanvasEndLabel">
        <div className="offcanvas-header">
          <h2 className="offcanvas-title" id="offcanvasEndLabel">Filter</h2>
          <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          <div className="accordion" id="accordion-filter">
            <div className="accordion-item">
              <h2 className="accordion-header" id="heading-1">
                <button className="accordion-button collapsed" type="button"
                  data-bs-toggle="collapse" data-bs-target="#collapse-createDate"
                  aria-expanded="false">
                  Created Date
                </button>
              </h2>
              <div id="collapse-createDate" className="accordion-collapse collapse"
                data-bs-parent="#accordion-filter">
                <div className="accordion-body pt-0">
                  <label className="form-label">From</label>
                  <div className="input-icon mb-2">
                    <input className="form-control" placeholder="Select a date"
                      id="datepicker-from" defaultValue="2020-06-20" />
                    <span className="input-group-text">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                        strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                        <path d="M4 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                        <path d="M6 4v4" />
                        <path d="M6 12v8" />
                        <path d="M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                        <path d="M12 4v10" />
                        <path d="M12 18v2" />
                        <path d="M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                        <path d="M18 4v1" />
                        <path d="M18 9v11" />
                      </svg>
                    </span>
                  </div>
                  <label className="form-label">To</label>
                  <div className="input-icon mb-2">
                    <input className="form-control" placeholder="Select a date"
                      id="datepicker-to" defaultValue="2020-06-20" />
                    <span className="input-group-text">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                        strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                        <path d="M4 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                        <path d="M6 4v4" />
                        <path d="M6 12v8" />
                        <path d="M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                        <path d="M12 4v10" />
                        <path d="M12 18v2" />
                        <path d="M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                        <path d="M18 4v1" />
                        <path d="M18 9v11" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="heading-2">
                <button className="accordion-button collapsed" type="button"
                  data-bs-toggle="collapse" data-bs-target="#collapse-company"
                  aria-expanded="false">
                  Company
                </button>
              </h2>
              <div id="collapse-company" className="accordion-collapse collapse"
                data-bs-parent="#accordion-filter">
                <div className="accordion-body pt-0">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      {/* Removed company filter select */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="offcanvas-footer">
          <div className="d-flex justify-content-end">
            <button type="button" className="btn btn-link link-secondary">Reset</button>
            <button type="button" className="btn btn-primary me-2">Apply</button>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="Success"
        message={successMessage}
        buttonText="OK"
      />

      <ConfirmationModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={confirmAction || (() => { })}
        title="Delete Partner"
        message="Are you sure you want to delete this partner? This action cannot be undone."
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
      />

      {/* Add FailModal */}
      <FailModal
        isOpen={showFailModal}
        onClose={() => setShowFailModal(false)}
        title="Operation Failed"
        message={failMessage}
        buttonText="Close"
      />

    </>
  );
};

export default IndividualPartner; 